export function getEventProximityQuery(radiusKm, discoveryLocation) {
  if (!Number.isFinite(radiusKm)) {
    return {
      radiusKm: undefined,
      latitude: undefined,
      longitude: undefined,
    };
  }

  return {
    radiusKm,
    latitude: discoveryLocation?.latitude,
    longitude: discoveryLocation?.longitude,
  };
}

export function getDirectoryLocationQuery(city, radiusKm, discoveryLocation) {
  const normalizedCity = typeof city === "string" ? city.trim() : "";

  if (!normalizedCity || normalizedCity === "Anywhere") return {};
  if (normalizedCity !== "Near me") return { city: normalizedCity };
  return getEventProximityQuery(radiusKm, discoveryLocation);
}
